/**
 * Formats a number or string as a currency value with dollar sign, thousands separator, and two decimal places.
 *
 * @param value - The number or string to format (can be a number, string representation of a number, or null/undefined)
 * @returns Formatted string in the format "$16,000.00" or "$0.00" for invalid/empty values
 *
 * @example
 * formatMoney(16000) // "$16,000.00"
 * formatMoney("16000.5") // "$16,000.50"
 * formatMoney(null) // "$0.00"
 */
export const formatMoney = (
  value: number | string | null | undefined
): string => {
  // Handle null, undefined, or empty string
  if (value === null || value === undefined || value === '') {
    return '$0.00';
  }

  // Convert to number
  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  // Handle NaN or invalid numbers
  if (isNaN(numValue)) {
    return '$0.00';
  }

  // Format with thousands separator and two decimal places
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numValue);
};
